import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Typography,
  Box,
} from '@mui/material';
import { reinstatePolicy } from '../../../../../../../lib/requests.es6';
import { getUserFullname, getUserGuid } from '../../../../../../../lib/access.es6';

export default function ReinstatePolicy(props) {
  const { open, onClose, policy, onSuccess } = props;

  const [reason, setReason] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [success, setSuccess] = React.useState(false);

  const handleClose = () => {
    if (loading) return;
    setReason('');
    setError(null);
    setSuccess(false);
    onClose && onClose();
  };

  const handleSubmit = async () => {
    if (!reason.trim()) {
      setError('Please provide a reason for reinstatement');
      return;
    }

    setLoading(true);
    setError(null);

    const payload = {
      policy_guid: policy.guid,
      execution_mode: 'immediate',
      execute_at: '',
      schedule_reason: '',
      notes: [
        {
          note: reason,
          type: 'reinstatement',
          web_user: getUserFullname(),
          web_user_guid: getUserGuid(),
        },
      ],
    };

    try {
      await reinstatePolicy(payload);
      setLoading(false);
      setSuccess(true);
      onSuccess && onSuccess();
    } catch (e) {
      setLoading(false);
      let message = 'An unexpected error occurred';
      if (e.response && e.response.data) {
        if (e.response.data.details && e.response.data.details.message) {
          message = e.response.data.details.message;
        } else if (e.response.data.message) {
          message = e.response.data.message;
        } else if (e.response.data.error) {
          message = e.response.data.error;
        }
      }
      setError(message);
    }
  };

  if (!policy) return null;

  return (
    <Dialog open={!!open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Reinstate Policy</DialogTitle>
      <DialogContent>
        {success ? (
          <Box sx={{ textAlign: 'center', padding: '20px 0' }}>
            <Typography variant="h6" style={{ color: '#155724' }}>
              Policy reinstated successfully
            </Typography>
          </Box>
        ) : (
          <>
            <Typography variant="body2" style={{ marginBottom: '15px' }}>
              Policy Number: <strong>{policy.policy_number}</strong>
            </Typography>
            <TextField
              autoFocus
              label="Reason for reinstatement"
              fullWidth
              multiline
              rows={4}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              disabled={loading}
            />
            {error && (
              <Typography
                variant="body2"
                style={{ color: '#721c24', marginTop: '10px' }}
              >
                {error}
              </Typography>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions>
        {success ? (
          <Button onClick={handleClose} variant="contained">
            Close
          </Button>
        ) : (
          <>
            <Button onClick={handleClose} disabled={loading}>
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              disabled={loading}
              startIcon={loading ? <CircularProgress size={16} /> : null}
            >
              {loading ? 'Reinstating...' : 'Reinstate'}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
